/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalCloseButton, Box, Flex, useToast } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { Formik, Form } from 'formik';
import { useMemo } from 'react';
import { gql, useMutation } from '@apollo/client';
import FileFormField from '../../../components/form/FileFormField';
import c from '../../../constant';
import * as Yup from 'yup';

const M_UPLOAD = gql`
	mutation uploadNpDoneFile($npId: String!, $file: Upload!, $fileSize: Float!) {
		uploadNpDoneFile(npId: $npId, file: $file, fileSize: $fileSize) {
			id
		}
	}
`;

function DoneFileModal({ npId = null, maxFileSize = 5242880, onClose = () => null, onCallback = () => null }) {
	const toast = useToast();
	const { t } = useTranslation();
	const [submitFile, { loading }] = useMutation(M_UPLOAD);

	const validationSchema = useMemo(
		() =>
			Yup.object().shape({
				file: Yup.mixed()
					.test('fileSize', 'over limit', (value) => {
						if (value) {
							return value?.size <= maxFileSize;
						} else {
							return true;
						}
					})
					.required('required'),
			}),
		[]
	);

	return (
		<Modal size="lg" closeOnEsc={!loading} closeOnOverlayClick={!loading} isOpen={true} onClose={onClose}>
			<ModalOverlay />
			<ModalContent borderRadius={c.borderRadius}>
				<ModalHeader pb={0} mb={0}>
					{t('Add done file')}
				</ModalHeader>
				<ModalCloseButton isDisabled={loading} />
				<ModalBody>
					<Formik
						initialValues={{ file: null }}
						validationSchema={validationSchema}
						onSubmit={(values) => {
							const file = values?.file || null;
							const fileSize = values?.file?.size || 0;
							const variables = { npId, file, fileSize };
							submitFile({ variables })
								.then(({ data }) => {
									onClose();
									onCallback();
								})
								.catch((error) => {
									if (error?.graphQLErrors?.length > 0) {
										error?.graphQLErrors.map(({ message }, i) =>
											toast({
												title: t(message),
												status: 'error',
												isClosable: true,
												position: 'bottom-right',
											})
										);
									} else {
										toast({
											title: t(error?.message ? error?.message : 'something went wrong'),
											status: 'error',
											isClosable: true,
											position: 'bottom-right',
										});
									}
								});
						}}
					>
						{({ values }) => (
							<Form>
								<Box mt="2">
									<>
										<FileFormField maxFileSize={maxFileSize} name="file" label="File" required={true} />
									</>
									<>
										<Flex flex="1" mt="6" mb={2} justifyContent="flex-end" alignItems="center">
											<Button type="submit" isLoading={loading} borderRadius={c.borderRadius} colorScheme="blue" onMouseDown={() => null}>
												{t('Submit')}
											</Button>
										</Flex>
									</>
								</Box>
							</Form>
						)}
					</Formik>
				</ModalBody>
			</ModalContent>
		</Modal>
	);
}

export default DoneFileModal;
